import axios from 'axios'

const HTTPInit = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

HTTPInit.defaults.headers.post['Content-Type'] = 'application/json'

HTTPInit.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error)
})

export const HTTP = HTTPInit
